module.exports = __webpack_public_path__ + "static/img/login_column_one01.9080034f.png";